module.exports = __webpack_public_path__ + "static/img/naturalCircle4.fb0cad3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naturalCircle4.svg
// module id = J1/b
// module chunks = 1